<template lang="pug">
.reservation-setting-tab(v-cloak)
  .register-body.mt-4
    //- 予約時間単位
    FormInputUnit(v-model="unit" name="reservation-unit")
    //- 家族ユーザーの予約可能日
    FormInputAvailableDate(v-model="availableDate" name="reservation-available-date")
    //- 面会スケジュールの使用
    FormInputReservationInputType(v-model="reservationInputType")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-type-help" title="面会スケジュールの使用について")
          template(v-slot:text)
            span
              span 施設で面会スケジュールを設定する場合は、
              strong 使用する
              span を選択し、更新後に
              strong 訪問面会日時の設定
              span からスケジュールを設定してください。
            br
            span
              strong 使用しない
              span を選択した場合は、ご家族は何時でも予約できるようになります。
    //- 家族ユーザーへの面会スケジュールの公開予約
    FormInputRadio(v-model="usePublishSchedule" key-name="家族ユーザーへの面会スケジュールの公開予約" name="use-publish-schedule"
      :options="_usePublishScheduleOptions" :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="use-publish-schedule-help-text" title="家族ユーザーへの面会スケジュールの公開予約について")
            template(v-slot:text)
              div
                strong 使用しない
                span の場合は面会スケジュールの登録後すぐにご家族がスケジュールを見られます。
                br
                strong 使用する
                span の場合は面会スケジュールの登録後すぐにご家族はスケジュールを見られず、次に設定いただく公開予約日時後に見られるようになります。
    //- 面会スケジュールの公開予約日時
    InputPublishDatetime(v-if="usePublishSchedule == true" v-model="publishDatetime" name="use-publish-datetime")
      template(v-slot:question)
        HelpIcon(popoverId="use-publish-datetime-help-text" title="面会スケジュールの公開予約日時について")
          template(v-slot:text)
            div
              span 面会スケジュールが登録されていても、公開予約日時以降にならないとご家族は面会スケジュールを見られません。
              br
              span 事前に面会スケジュールを登録して、指定した公開日時にご家族にご案内したい場合などにご利用ください。
              br
              br
              span 例（25日の10時に設定した場合）
              br
              span 7月の面会スケジュールを6月25日の10時に公開します。
    //- 面会スケジュールの単位
    FormInputGroupUseType(v-model="groupUseType" :active="useSchedule && 1 <= planType" name="reservation-group-use-type")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-group-use-help" title="面会スケジュールの単位について")
          template(v-slot:text)
            span
              strong 利用者グループ（例えばフロア）
              span を選択した場合、
              strong 利用者グループ
              span ごとに訪問面会スケジュールを設定することができます。
            br
            span
              span 利用者グループ設定を使用する為には、利用者画面の
              strong グループ設定
              span で利用者グループを作成し、グループの所属利用者を設定する必要があります。
            br
            br
            span
              strong 施設全体
              span を選択した場合、
              span 施設全体で１つの訪問面会スケジュールを設定します。
    //- 予約可能数のカウント範囲
    FormInputReservationCountType(v-model="countType" :active="useScheduleAndGroup && 1 <= planType" name="reservation-count-type")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-count-type-help" title="予約可能数のカウント範囲について")
          template(v-slot:text)
            span
              span 予約枠あたりの予約数を
              strong 施設全体
              span でカウントするか、
              strong 同一利用者グループ内
              span のみでカウントするかを設定できます。
            br
            br
            span
              strong 施設全体
              span ：全ての利用者グループの予約数を合算し、その予約数が予約可能数に達すると予約できなくなります。
            br
            span
              strong 同一利用者グループ内
              span ：利用者グループ単位の予約数が予約可能数に達すると、その利用者グループの予約はできなくなります。
    //- 予約枠あたりの予約可能数
    FormInputReservationPerCounts(v-model="reservationPerCounts" :active="useSchedule" name="reservation-count")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-per-counts-help" title="予約枠あたりの予約可能数について")
          template(v-slot:text)
            span １つの予約時間枠に予約可能な上限数を設定できます。
            br
            span ただし上限数に達していない場合でも、同一予約時間枠に同じ利用者のご家族が予約している場合は予約できません。
            span また、同一予約時間枠に同じ利用者のご家族がオンライン面会予約している場合も予約できません。
    //- 利用者ごとの予約間隔制限
    FormInputIntervalLimit(v-model="intervalLimit" :active="useSchedule" name="reservation-interval-limit")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-interval-help" title="利用者ごとの予約間隔制限について")
          template(v-slot:text)
            span
              strong 利用者の家族単位
              span で訪問面会予約の
              strong 間隔を制限
              span することができます。
            br
            br
            span
              span 例えば東京花子様という利用者に東京太郎様と東京次郎様という２名の家族が登録している場合、東京太郎様が面会予約すると、東京次郎様も東京太郎様と同じ予約間隔制限を受けます。
    //- 利用者ごとの同月内の予約可能な面会数
    FormInputVisitsLimitOfMonth(v-model="visitsLimitOfMonth" :active="useSchedule" name="reservation-visits-limit-of-month-limit")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-visits-limit-of-month-help" title="利用者ごとの同月内の予約可能な面会数について")
          template(v-slot:text)
            span
              strong 利用者の家族単位
              span で訪問面会予約の
              strong 同月内の面会数を制限
              span することができます。
            br
            br
            span
              span 例えば東京花子様という利用者に東京太郎様と東京次郎様という２名の家族が登録している場合、東京太郎様が面会予約すると、東京次郎様も東京太郎様と同じ同月内面会数制限を受けます。
    //- 利用者ごとの同時に予約可能な面会数
    FormInputConcurrentNumberLimit(v-model="concurrentNumberLimit" name="reservation-concurrent-number-limit")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-concurrent-help" title="利用者ごとの同時に予約可能な面会数について")
          template(v-slot:text)
            span
              span 利用者の家族単位で
              strong 同時に予約可能な面会数
              span を制限することができます。
            br
            span
              strong 面会終了後にならないと次の予約が出来ない
              span ようにすることもできます
    //- 利用者ごとの同時に予約可能な面会数の家族ユーザー表示
    FormInputRadio(v-model="showConcurrentNumberLimit" key-name="同時に予約可能な面会数の家族ユーザー表示" name="showConcurrentNumberLimit"
      :options="showConcurrentNumberLimitOptions" :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="showConcurrentNumberLimit-help-text" title="同時に予約可能な面会数の家族ユーザー表示について")
            template(v-slot:text)
              div 家族ユーザーの面会予約ページに「同時に予約可能な回数」を表示するかどうかを選択できます。
    //- 利用者ごとの予約制限の確認対象
    FormInputReservationLimitType(v-model="limitType" :reservationType="0" name="reservation-limit-type")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-limit-type-help" title="利用者ごとの予約制限の確認対象について")
          template(v-slot:text)
            strong 利用者ごとの予約間隔制限
            span と
            strong 利用者ごとの同時に予約可能な面会数
            span の
            strong 確認対象の面会予約
            span を選択できます。
    //- 面会場所
    FormInputRadio(v-model="useLocation" key-name="面会場所" name="use-location" :options="_useLocationOptions" :validation-rules="{ required: true }" required)
      template(v-slot:question)
        HelpIcon(popoverId="use-location-help-text" title="面会場所について")
          template(v-slot:text)
            div
              strong 使用する
              span にすると、面会予約時に
              strong 面会場所の選択
              span ができるようになります。
              br
              strong 選択肢を自由に作成
              span し（居室や面会室など）、その選択肢ごとの
              strong 同時予約可能数
              span を設定できます。
    //- 面会場所の選択肢
    .location-options(v-if="useLocation == true")
      .title.d-flex.flex-row.align-items-center
        span.key-name 面会場所の選択肢
        span.validation-label 必須
      .location.mb-2(v-for="(option, index) in locationOptions" :key="index")
        InputLocation(v-model="locationOptions[index]" :name="'location-option-' + index" @onDelete="deleteLocationOption(index)")
      .error-messages(v-for="error in errors.collect('location-options')")
        label.error-message {{ error }}
        br
      button.btn(@click="addLocationOption" :class="{ 'disable': _disableAddLocationOption }" :disabled="_disableAddLocationOption") 追加

    //- 自動承諾
    FormInputReservationAutoApproval(v-model="autoApproval" name="reservation-auto-approval")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-auto-approval-help" title="自動承諾について")
          template(v-slot:text)
            span
              span 自動承諾に設定すると、家族ユーザーからの予約申込時にシステムで自動的に承諾にします。
    //- 家族ユーザーへの案内
    FormTextarea(key-name="家族ユーザーへの連絡事項" name="description" v-model="description" placeholder="例：毎月中旬頃に翌月の面会スケジュールを公開いたします。多くのご家族が面会できるように、ご家族ごとに2週間間隔の面会予約制限を設けております。"
      :validation-rules="{ max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '700px', width: '700px', minHeight: '160px' }")
      template(v-slot:question)
        HelpIcon(popoverId="form-textarea-description-help" title="家族ユーザーへの連絡事項について")
          template(v-slot:text)
            span 入力内容は、ご家族の訪問面会予約の申込みページに「施設からの連絡事項」として表示されます。
    //- 家族からの連絡の使用可否
    FormInputUseText(v-model="useText" name="reservation-use-text")
    //- 家族ユーザーからの面会予約の受付中もしくは停止中
    FormInputCanReservation(v-model="canReservation" name="reservation-can-reservation")

    .register-row(v-show="errorMessage")
      .register-group
        .register-value
          .error-message {{ errorMessage }}

  .box-footer.register-footer
    ValidationAlert(v-model="showValidationAlert")
    .buttons.m-0
      button.btn.update-btn(@click="showConfirmUpdateModal" type="button") 更新
      button.btn.cancel-btn(@click="gotoReservationList" type="button") キャンセル

  OkCancelModal(v-model="showUpdateModal" title="訪問面会の基本設定を更新しますか？" @ok="updateReservationSetting")
  OkModal(v-model="showUpdateSuccessModal" title="更新に成功しました。" @ok="gotoReservationList")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Watch, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import CustomValidate from "@/commons/utils/CustomValidate";
import { PcUrl } from "@/commons/constants/PcUrl";
import ReservationSettingsService, {
  ReservationInputType,
  ReservationSettingsGetModel,
  ReservationSettingsPatchModel,
  GroupUseType,
  CountType,
  LimitType,
  VisitsLimitOfMonth,
  ReservationUnit,
  AvailableDate,
  ReservationPerCounts,
  IntervalLimit,
  ConcurrentNumberLimit,
  PublishDatetime,
  LocationOption
} from "@/commons/services/ReservationSettings";
import SystemError from "@/commons/models/SystemError";
import { PlanType } from "@/commons/services/Plans";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInputUnit from "@/pc/components/reservations/FormInputUnit.vue";
import FormInputAvailableDate from "@/pc/components/reservations/FormInputAvailableDate.vue";
import FormInputReservationPerCounts from "@/pc/components/reservations/FormInputReservationPerCounts.vue";
import FormInputReservationCountType from "@/pc/components/reservations/FormInputReservationCountType.vue";
import FormInputIntervalLimit from "@/pc/components/reservations/FormInputIntervalLimit.vue";
import FormInputVisitsLimitOfMonth from "@/pc/components/reservations/FormInputVisitsLimitOfMonth.vue";
import FormInputConcurrentNumberLimit from "@/pc/components/reservations/FormInputConcurrentNumberLimit.vue";
import FormInputReservationLimitType from "@/pc/components/reservations/FormInputReservationLimitType.vue";
import FormInputCanReservation from "@/pc/components/reservations/FormInputCanReservation.vue";
import FormInputGroupUseType from "@/pc/components/reservations/FormInputGroupUseType.vue";
import FormInputReservationInputType from "@/pc/components/reservations/FormInputReservationInputType.vue";
import FormInputReservationAutoApproval from "@/pc/components/reservations/FormInputReservationAutoApproval.vue";
import FormInputUseText from "@/pc/components/reservations/FormInputUseText.vue";
import InputPublishDatetime from "@/pc/components/reservations/InputPublishDatetime.vue";
import InputLocation from "@/pc/components/reservations/InputLocation.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import FormInputRadio from "@/pc/components/forms/FormInputRadio.vue";

/**
 * 訪問面会設定コンポーネント
 */
@Component({
  components: {
    FormInputUnit,
    FormInputAvailableDate,
    FormInputReservationPerCounts,
    FormInputReservationCountType,
    FormInputIntervalLimit,
    FormInputVisitsLimitOfMonth,
    FormInputConcurrentNumberLimit,
    FormInputReservationLimitType,
    FormInputCanReservation,
    FormInputGroupUseType,
    FormInputReservationInputType,
    FormInputReservationAutoApproval,
    FormInputUseText,
    OkCancelModal,
    OkModal,
    HelpIcon,
    PageLoading,
    ValidationAlert,
    FormTextarea,
    FormInputRadio,
    InputPublishDatetime,
    InputLocation
  },
  $_veeValidate: { validator: "new" }
})
export default class ReservationSettingTab extends Vue {
  /** 訪問面会設定サービス */
  @Inject("ReservationSettingsService") reservationSettingsService!: ReservationSettingsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 更新確認モーダル表示可否 */
  showUpdateModal: boolean = false;
  /** 更新完了モーダル表示可否 */
  showUpdateSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** 単位 */
  unit: ReservationUnit = ReservationUnit.FIFTEEN_MINUTES;
  /** 何日前まで予約できるか */
  availableDate: AvailableDate = AvailableDate.TODAY;
  /** 訪問予約入力種別 */
  reservationInputType: ReservationInputType = ReservationInputType.FREE;
  /** 家族ユーザーへの面会スケジュールの公開予約機能を使用するか */
  usePublishSchedule: boolean = false;
  /** 面会スケジュールの公開予約日時 */
  publishDatetime: PublishDatetime | null = null;
  /** 面会スケジュールの単位 */
  groupUseType: GroupUseType = GroupUseType.DISUSE;
  /** 予約枠あたりの予約可能数 */
  reservationPerCounts: ReservationPerCounts = ReservationPerCounts.ONE;
  /** 予約可能数のカウント範囲 */
  countType: CountType = CountType.GROUP;
  /** 利用者ごとの予約間隔制限 */
  intervalLimit: IntervalLimit = IntervalLimit.NO_LIMIT;
  /** 利用者ごとの同月内の予約可能な面会数 */
  visitsLimitOfMonth: VisitsLimitOfMonth = VisitsLimitOfMonth.NO_LIMIT;
  /** 利用者ごとの同時に予約可能な面会数 */
  concurrentNumberLimit: ConcurrentNumberLimit = ConcurrentNumberLimit.NO_LIMIT;
  /** 利用者ごとの同時に予約可能な面会数の家族ユーザー表示 */
  showConcurrentNumberLimit: boolean = false;
  /** 利用者ごとの同時に予約可能な面会数の家族ユーザー表示の選択肢 */
  showConcurrentNumberLimitOptions: Array<{ value: boolean; label: string }> = [
    { value: true, label: "表示する" },
    { value: false, label: "表示しない" }
  ];
  /** 利用者ごとの予約制限の確認対象 */
  limitType: LimitType = LimitType.SEPARATE;
  /** 家族ユーザーからの面会予約の受付中もしくは停止中 */
  canReservation: boolean = false;
  /** 訪問予約入力種別がスケジュールか否か */
  useSchedule: boolean = false;
  /** 訪問予約入力種別がスケジュールかつ利用者グループ使用か否か */
  useScheduleAndGroup: boolean = false;
  /** 面会場所を使用するか否か */
  useLocation: boolean = false;
  /** 面会場所の選択肢 */
  locationOptions: Array<LocationOption> = [];
  /** 自動承諾を使用するか否か */
  autoApproval: boolean = false;
  /** 家族ユーザーへの案内 */
  description: string | null = null;
  /** 家族からの連絡の使用可否 */
  useText: boolean = false;
  /** 更新日時 */
  updated: number = 0;
  /** エラーメッセージ */
  errorMessage: string = "";

  get _usePublishScheduleOptions(): Array<{ value: boolean; label: string }> {
    return [
      { value: false, label: "使用しない" },
      { value: true, label: "使用する" }
    ];
  }

  get _useLocationOptions(): Array<{ value: boolean; label: string }> {
    return [
      { value: false, label: "使用しない" },
      { value: true, label: "使用する" }
    ];
  }

  /**
   * ### 訪問予約入力種別の値監視
   *
   * - 訪問予約入力種別に応じて訪問予約入力種別がスケジュールか否かを更新する
   */
  @Watch("reservationInputType")
  public changeReservationInputType(newValue: ReservationInputType): void {
    if (newValue == ReservationInputType.FREE) {
      this.useSchedule = false;
      this.useScheduleAndGroup = false;
    } else if (newValue == ReservationInputType.SCHEDULE) {
      this.useSchedule = true;
      if (this.groupUseType == GroupUseType.DISUSE) {
        this.useScheduleAndGroup = false;
      } else {
        this.useScheduleAndGroup = true;
      }
    } else {
      this.useSchedule = false;
      this.useScheduleAndGroup = false;
    }
    return;
  }

  /**
   * ### 利用者グループ使用有無の値監視
   *
   * - 利用者グループ使用有無に応じて訪問予約入力種別がスケジュールかつ利用者グループ使用か否かを更新する
   */
  @Watch("groupUseType")
  public changeGroupUseType(newValue: GroupUseType): void {
    if (newValue == GroupUseType.DISUSE) {
      this.useScheduleAndGroup = false;
    } else if (newValue == GroupUseType.USE) {
      if (this.reservationInputType == ReservationInputType.FREE) {
        this.useScheduleAndGroup = false;
      } else {
        this.useScheduleAndGroup = true;
      }
    } else {
      this.useScheduleAndGroup = false;
    }
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public created() {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.planType = userStore.facility.planType;

    await this.createView();

    this.isBusy = false;

    return;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    const setting: ReservationSettingsGetModel = await this.getReservationSetting();

    // 編集してAPIにPATCHメソッドで渡すので、値は個別に保持する
    this.unit = setting.unit;
    this.availableDate = setting.availableDate;
    this.reservationPerCounts = setting.reservationPerCounts;
    this.countType = setting.countType;
    this.intervalLimit = setting.intervalLimit;
    this.visitsLimitOfMonth = setting.visitsLimitOfMonth;
    this.concurrentNumberLimit = setting.concurrentNumberLimit;
    this.showConcurrentNumberLimit = setting.showConcurrentNumberLimit;
    this.limitType = setting.limitType;
    this.canReservation = setting.canReservation;
    this.groupUseType = setting.groupUseType;
    this.reservationInputType = setting.reservationInputType;
    this.usePublishSchedule = setting.usePublishSchedule;
    // 値が無い場合は初期値を格納する
    if (!setting.publishDatetime) {
      this.publishDatetime = {
        date: 1,
        hour: 0
      };
    } else {
      this.publishDatetime = setting.publishDatetime;
    }
    this.useLocation = setting.useLocation;
    this.locationOptions = setting.locationOptions;
    this.autoApproval = setting.autoApproval;
    this.description = setting.description;
    this.useText = setting.useText;
    this.updated = setting.updated;

    return;
  }

  /**
   * ### 訪問面会設定取得
   */
  public async getReservationSetting(): Promise<ReservationSettingsGetModel> {
    const response: ReservationSettingsGetModel = await this.reservationSettingsService.get(userStore);
    return response;
  }

  /** ### 面会場所の選択肢の削除 */
  deleteLocationOption(index: number): void {
    this.locationOptions.splice(index, 1);
    return;
  }

  /** ### 面会場所の選択肢の追加 */
  addLocationOption(): void {
    if (!this.locationOptions) this.locationOptions = [];
    this.locationOptions.push({
      name: "",
      concurrentNumberLimit: 0
    });
    return;
  }

  /**
   * ### 面会場所の選択肢の追加可否
   *
   * - 10件まで追加可能
   */
  get _disableAddLocationOption(): boolean {
    if (!this.locationOptions) {
      return true;
    } else {
      if (this.locationOptions.length < 10) {
        return false;
      } else {
        return true;
      }
    }
  }

  /**
   * ### 登録確認モーダルを表示する
   *
   * - 表示前にバリデーションチェックして、エラーならモーダルは表示しない
   */
  public async showConfirmUpdateModal(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    const requireLocationNameValidationResult: boolean = this.validateRequireLocationName(this.locationOptions);
    const duplicateLocationNameValidationResult: boolean = this.validateDuplicateLocationName(this.locationOptions);
    if (validationResult && requireLocationNameValidationResult && duplicateLocationNameValidationResult) {
      this.showValidationAlert = false;
      this.showUpdateModal = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /** ### 面会場所選択肢の必須チェック */
  private validateRequireLocationName(locationOptions: Array<LocationOption>): boolean {
    // 面会場所を使用しない場合はチェック不要
    if (!this.useLocation) {
      return true;
    }

    // 1件もなければエラー
    if (!locationOptions || locationOptions.length < 1) {
      this.$validator.errors.add({ field: "location-options", msg: `面会場所は1件以上必要です` });
      return false;
    } else {
      return true;
    }
  }

  /** ### 面会場所選択肢の面会場所名の重複チェック */
  private validateDuplicateLocationName(locationOptions: Array<LocationOption>): boolean {
    // 面会場所を使用しない場合はチェック不要
    if (!this.useLocation) {
      return true;
    }

    // nameプロパティだけを抽出した配列を作成
    const names = locationOptions.map((option) => option.name);
    // Setオブジェクトのサイズと元の配列のサイズを比較
    // Setは重複要素を自動的に削除するため、サイズが異なれば重複がある
    const uniqueNames = new Set(names);

    if (uniqueNames.size !== names.length) {
      this.$validator.errors.add({ field: "location-options", msg: `面会場所名が重複しています` });
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### 訪問面会設定更新
   */
  public async updateReservationSetting(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      const updateParam: ReservationSettingsPatchModel = await this.createUpdateParam();
      await this.reservationSettingsService.patch(userStore, updateParam);

      this.showUpdateSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      } else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 施設更新パラメータ作成
   */
  public async createUpdateParam(): Promise<ReservationSettingsPatchModel> {
    const updateParam: ReservationSettingsPatchModel = {
      unit: this.unit,
      availableDate: this.availableDate,
      reservationPerCounts: this.reservationPerCounts,
      countType: this.countType,
      intervalLimit: this.intervalLimit,
      visitsLimitOfMonth: this.visitsLimitOfMonth,
      concurrentNumberLimit: this.concurrentNumberLimit,
      showConcurrentNumberLimit: this.showConcurrentNumberLimit,
      limitType: this.limitType,
      canReservation: this.canReservation,
      groupUseType: this.groupUseType,
      reservationInputType: this.reservationInputType,
      usePublishSchedule: this.usePublishSchedule,
      publishDatetime: this.publishDatetime,
      autoApproval: this.autoApproval,
      useLocation: this.useLocation,
      locationOptions: this.useLocation ? this.locationOptions : [],
      description: this.description ? this.description : null,
      useText: this.useText,
      updated: this.updated
    };

    return updateParam;
  }

  /**
   * ### 予約一覧画面に遷移する
   */
  public gotoReservationList(): void {
    this.$router.push(PcUrl.ReservationList);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_mixin.scss";
@import "../../../styles/pc/_colors.scss";

.reservation-setting-tab {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;

  .location-options {
    margin: 0 20px 16px 20px;

    .key-name {
      @include bold-font(18px);
      margin: 0 6px 0 0;
    }
    .title {
      margin: 0 0 4px 0;
      .validation-label {
        @include validation-label();
      }
    }
    .btn {
      margin: 0 0 8px 0;
    }
  }

  .update-btn,
  .cancel-btn {
    width: 120px;
  }

  .box-footer {
    padding: 10px 0 0 0 !important;
  }
}
</style>
